import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApp } from '../context/AppContext';

//import resources
import Bog from '../assets/images/banks/bog.png';
import Tbc from '../assets/images/banks/tbc.png';
import Liberty from '../assets/images/banks/liberty.png';

//import tags
import { toast, Bounce } from 'react-toastify';
import { PulseLoader } from "react-spinners";

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";


//import api
import FetchData from "../api/Api";

export default function Checkout() {

    //get context

    const { toCart, setToCart, user } = useApp();


    //get locale
    const { t } = useTranslation();
    const { locale } = useParams();

    //get data
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

   

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchDataInstance = new FetchData();
                const result = await fetchDataInstance.action(`/api/cart`, toCart, false);
                
                // Set data only if it's null or needed
                if (data === null) {
                    setData(result);
                }
    
    
            } catch (error) {
                console.error("Failed to get data:", error.message);
            }
        };
    
        // Fetch data when necessary conditions change
        if (data === null) {
            setTimeout(function() {
                fetchData();
            }, 200)
        }
    
    }, [data, toCart]);

    //bog loan
    const loadScript = () => {
        return new Promise((resolve, reject) => {
        if (window.BOG && window.BOG.Calculator) {
            return resolve(); // already loaded
        }

        const existingScript = document.getElementById('bog-sdk');
        if (existingScript) {
            existingScript.onload = () => resolve();
            existingScript.onerror = () => reject();
            return;
        }

        const script = document.createElement('script');
        script.id = 'bog-sdk';
        script.src = 'https://webstatic.bog.ge/bog-sdk/bog-sdk.js?version=2&client_id=10001711';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.body.appendChild(script);
        });
    };

    // bog loan
    
    
    const addMethod = (e) => {

        let method = e.currentTarget.getAttribute('data-method');

        setToCart((prevCart) => ({
            ...prevCart,
            paymethod: method
        }))
    }


    const pay = () => {
        setLoading(true);
        const fetchData = async () => {
            
            try {
                const fetchDataInstance = new FetchData();
                await fetchDataInstance.initHeaders(locale, localStorage.getItem('token'));

                let result = null;

                if(toCart?.paymethod === 'BOG_LOAN') {
                    
                    try {
                        await loadScript();
                        
                        window.BOG.Calculator.open({
                            amount: data?.data?.total_price,
                            onClose: () => {
                                // Modal close callback
                            },
                            onRequest: async (selected, successCb, closeCb) => {
                                const { amount, month, discount_code } = selected;
                                const bodyData = {
                                    ...selected,
                                    ...toCart // merge toCart fields into the body
                                };

                                result = await fetchDataInstance.action(`/api/checkout`, bodyData, true);

                                if (result?.status === 'OK') {
                                    window.location.href = result.redirect;
                                }
                                
                                // fetch(process.env.REACT_APP_API_URL+'/api/checkout', {
                                //     method: 'POST',
                                //     body: JSON.stringify(bodyData)
                                // })
                                // .then(response => response.json())
                                // .then(data => successCb(data.orderId))
                                // .catch(err => closeCb());
                            },
                            onComplete: ({redirectUrl}) => {
                                return false;
                            }
                        })
                    } catch (err) {
                        console.error('Failed to load BOG SDK script:', err);
                    }

                    //result = await fetchDataInstance.action(`/api/checkout`, toCart, true);
                } else {
                    result = await fetchDataInstance.action(`/api/checkout`, toCart, true);
                }

                
                
                

                if (result?.status === 'OK') {
                    if(toCart?.paymethod === 'BOG_CARD') {
                        window.location.href = result.redirect;
                    } else if(toCart?.paymethod === 'TBC_CARD') {
                        window.location.href = result.redirect;
                    } else if(toCart?.paymethod === 'LIBERTY_CARD') {
                        const form = document.createElement("form");
                        form.method = "POST";
                        form.action = "https://www.pay.ge/pay";

                        for (const key in result?.form_data) {
                            const input = document.createElement("input");
                            input.type = "hidden";
                            input.name = key;
                            input.value = result?.form_data[key] !== null ? result?.form_data[key] : "";
                            form.appendChild(input);
                        }

                        document.body.appendChild(form);
                        form.submit();
                    }
                    
                }

                setLoading(false);
    
            } catch (error) {
                console.error("Failed to get data:", error.message);
            }
        };
    
        // Fetch data when necessary conditions change
        if(user !== null) {
            setTimeout(function() {
                fetchData();
            }, 200)
        } else {
            toast.error(t('please_login'), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
            });
        }
        
        
    }

    

    return (
        <>
            <Breadcrumb title={t('checkout')} />
            <div className='container mx-auto mt-12'>
                <div className='grid grid-cols-12 gap-5'>
                    <div className='col-span-9 grid-cols-12 grid gap-5'>
                        <div className='col-span-12'>
                            <div className='upper font-semibold'>{t('choose_card')}</div>
                        </div>
                        <div className='col-span-4'>
                            <div onClick={(e)=>addMethod(e)} data-method="BOG_CARD" className={`${toCart?.paymethod === 'BOG_CARD' ? 'bg-gray-100' : ''} border border-gray-150 col-span-3 p-5 text-center shadow-lg rounded-xl h-[200px] flex items-center justify-center cursor-pointer hover:shadow-none duration-500`}>
                                <img src={`${Bog}?v=1`} className='w-[90%]' alt='Bank of Georgia' />
                            </div>
                        </div>
                        <div className='col-span-4'>
                            <div onClick={(e)=>addMethod(e)} data-method="TBC_CARD" className={`${toCart?.paymethod === 'TBC_CARD' ? 'bg-gray-100' : ''} border border-gray-150 col-span-3 p-5 text-center shadow-lg rounded-xl h-[200px] flex items-center justify-center cursor-pointer hover:shadow-none duration-500`}>
                                <img src={`${Tbc}?v=2`} className='w-[90%]' alt='TBC bank' />
                            </div>
                        </div>
                        <div className='col-span-4'>
                            <div onClick={(e)=>addMethod(e)} data-method="LIBERTY_CARD" className={`${toCart?.paymethod === 'LIBERTY_CARD' ? 'bg-gray-100' : ''} border border-gray-150 col-span-3 p-5 text-center shadow-lg rounded-xl h-[200px] flex items-center justify-center cursor-pointer hover:shadow-none duration-500`}>
                                <img src={`${Liberty}?v=2`} className='w-[90%]' alt='Liberty bank' />
                            </div>
                        </div>
                        <div className='col-span-12 mt-10'>
                            <div className='upper font-semibold'>{t('choose_loan')}</div>
                        </div>
                        <div className='col-span-4'>
                            <div onClick={(e)=>addMethod(e)} data-method="BOG_LOAN" className={`${toCart?.paymethod === 'BOG_LOAN' ? 'bg-gray-100' : ''} border border-gray-150 col-span-3 relative p-5 text-center shadow-lg rounded-xl h-[200px] flex flex-col items-center justify-center cursor-pointer hover:shadow-none duration-500`}>
                                <img src={`${Bog}?v=1`} className='w-[90%]' alt='Bank of Georgia' />
                                <div className='mb-5 font-bold absolute bottom-0'>{t('loan')}</div>
                            </div>
                        </div>
                        {/* <div className='col-span-4'>
                            <div onClick={(e)=>addMethod(e)} data-method="TBC_LOAN" className={`${toCart?.paymethod === 'TBC_LOAN' ? 'bg-gray-100' : ''} border border-gray-150 col-span-3 relative p-5 text-center shadow-lg rounded-xl h-[200px] flex flex-col items-center justify-center cursor-pointer hover:shadow-none duration-500`}>
                                <img src={`${Tbc}?v=2`} className='w-[90%]' />
                                <div className='mb-5 font-bold absolute bottom-0'>{t('loan')}</div>
                            </div>
                        </div>
                        <div className='col-span-4'>
                            <div onClick={(e)=>addMethod(e)} data-method="LIBERTY_LOAN" className={`${toCart?.paymethod === 'LIBERTY_LOAN' ? 'bg-gray-100' : ''} border border-gray-150 col-span-3 relative p-5 text-center shadow-lg rounded-xl h-[200px] flex flex-col items-center justify-center cursor-pointer hover:shadow-none duration-500`}>
                                <img src={Liberty} className='w-[90%]' />
                                <div className='mb-5 font-bold absolute bottom-0'>{t('loan')}</div>
                            </div>
                        </div> */}
                    </div>
                    <div className='col-span-3'>
                        <div className="border border-gray-150 col-span-3 p-5 shadow-lg rounded-xl">
                            <div className='upper font-semibold border-b border-[var(--orange)] pb-2 mb-5 text-center'>{t('payment_details')}</div>
                            <div>
                                <div className='text-[14px] flex justify-between mb-2'>
                                    <span>{t('total_amount')}:</span> {data?.data?.total_quantity} ც
                                </div>
                                <div className='text-[14px] flex justify-between mb-2'>
                                    <span>{t('total_price')}:</span> {data?.data?.total_price} ₾
                                </div>
                                <div className='text-[14px] flex justify-between'>
                                    <span>{t('promo_code')}:</span> {data?.data?.promo_discount ? '-' + data.data.promo_discount + '₾': '--'}
                                </div>
                                <div>
                                    <button onClick={!loading ? pay : undefined} className="bg-[var(--orange)] text-white px-7 py-3 rounded-lg hover:shadow-md block text-center mt-5 w-full">
                                        { loading ? <PulseLoader size="8" color="#fff" /> : t('continue_shopping')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </>
    );
}

